import React from "react";
import { rateSetModel } from "../rateSetModel";
import { ISearchField, SearchTypeEnum } from "@components/YhPageHeader/Types";
import { YhPageHeader } from "@components/YhPageHeader";



export function PageHeader() {
    const {
        searchParam,
        onReset,
        loadData,
        updateSearchParam,
        appDs
    } = rateSetModel();

    const searchFields: ISearchField[] = [

        {
            type: SearchTypeEnum.Select,
            xxl: 4,
            span: 4,
            placeholder: "系统",
            fieldName: "appCode",
            size: "small",
            disabled: false,
            options: appDs
        },
        {
            type: SearchTypeEnum.Input,
            xxl: 4,
            span: 4,
            placeholder: "反馈人",
            fieldName: "createUser",
            size: "small",
            disabled: false,
        },
        {
            type: SearchTypeEnum.RangePicker,
            fieldName: "",
            // rangePickerFieldName: ["startTime", "endTime"],
            placeholder: ["起始日期", "结束日期"],
            format: "YYYY-MM-DD",
            xxl: 8,
            span: 4,
            timeIsT: true
        },
    ]


    return (
        <YhPageHeader
            title="系统评价"
            searchValues={searchParam}
            searchFields={searchFields}
            onChange={updateSearchParam}
            triggerSearch
            handleSearch={(val = {}) => loadData({ pageNum: 1 }, { ...searchParam, ...val })}
            handleReset={onReset}
        />
    );
}